import React, { useState, memo, useCallback } from "react";
import { useRecoilState } from "recoil";

import { availableState } from '../../../store/availableState';

import { NewAcceptanceResult } from '../parts/NewAcceptanceResult';
import { EditAcceptanceResult } from '../parts/EditAcceptanceResult';

export const AvailableAcceptanceResult = (props) => {
  const { init_hospital, corporations } = props;
  const [availableData, setAvailableData] = useRecoilState(availableState);

  const addAvailable = useCallback((new_item) => {
    setAvailableData([...availableData, new_item]);
  }, [availableData]);

  const removeAvailable = useCallback((remove_item) => {
    setAvailableData(availableData.filter(item => {
      return item.id !== remove_item;
    }));
  }, [availableData]);

  return (
    <>
      <NewAcceptanceResult hospital_id={init_hospital.id} corporations={corporations} addAcceptanceResult={addAvailable} type_val='Available' />
      <div className="row">
        <table className="table table-striped table-hover mb-3">
          <tbody>
          {availableData.map(available => 
              <EditAcceptanceResult key={available.id} init_acceptance_result={available} removeAcceptanceResult={removeAvailable} />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};